<div class="page-title-area">
    <img src="assets/images/upgrade_banner_new.png" alt="Page Background" class="page-bg">
    <button class="back-arrow-btn" (click)="navigateToHome()">
        <i class="fas fa-chevron-left fa-2x"></i>
    </button>
    <div class="container">
        <div class="page-title-content">
            <h2>Exclusive Apple Upgrade Program</h2>
        </div>
    </div>

</div>

<section class="animated-cards-section ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <div class="innovation-image">
                    <div class="circular-image-container">
                        <img src="assets/images/apple_upgrade12.png" alt="Apple Upgrade" class="circular-image">
                       <!--  <div class="icon-overlay">
                            <i class="fas fa-sync-alt"></i>
                            <i class="fas fa-dollar-sign"></i>
                            <i class="fas fa-shield-alt"></i>
                            <i class="fas fa-rocket"></i>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="innovation-content">
                    <h2 class="slide-in" data-delay="0">Apple Upgrade Program</h2>
                    <div class="feature-list">
                        <div class="feature-item slide-in" data-delay="200">
                            <i class="fas fa-sync-alt"></i>
                            <p>Seamless device upgrades with competitive buyback for your existing Macs</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="400">
                            <i class="fas fa-dollar-sign"></i>
                            <p>Flexible financing options to upgrade without heavy upfront investment</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="600">
                            <i class="fas fa-shield-alt"></i>
                            <p>Advanced security features and Apple Silicon performance for enhanced productivity</p>
                        </div>
                        <div class="feature-item slide-in" data-delay="800">
                            <i class="fas fa-rocket"></i>
                            <p>Comprehensive support including data migration and zero-touch deployment</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1000" style="background: linear-gradient(135deg, #007bff, #0056b3);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-sync-alt"></i>
                        </div>
                        <h3>Easy Upgrade Process</h3>
                        <p>Streamline your device refresh cycle with our hassle-free upgrade program.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1200" style="background: linear-gradient(135deg, #28a745, #218838);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-dollar-sign"></i>
                        </div>
                        <h3>Smart Investment</h3>
                        <p>Maximize your IT budget with competitive buyback and flexible financing.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="animated-card slide-in" data-delay="1400" style="background: linear-gradient(135deg, #ce202f, #a51c2a);">
                    <div class="card-content">
                        <div class="card-icon">
                            <i class="fas fa-rocket"></i>
                        </div>
                        <h3>Enhanced Performance</h3>
                        <p>Boost productivity with the latest Apple Silicon and advanced features.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>
<br>